import { useContext, useEffect } from 'react'
import ApiService from '../../common/ApiCalls'
import { isAllowedToViewTab, isAllowedToView } from '../permissions/permissionHelper'
import { GlobalContext } from '../context/DataContext'

const useTabsNav = () => {
  const { tabsData, permissionsData, id } = useContext(GlobalContext)
  const [tabs, setTabs] = tabsData
  const [permissions] = permissionsData
  const canViewTabs = isAllowedToViewTab(id[0])

  useEffect(()=>{
    const getTabs = async () => {
      const res = await ApiService().getTabs()

      const tabsCopy = [...(Array.isArray(res) ? res : []), ...tabs]
      tabsCopy[0].isDisabled = !canViewTabs
      tabsCopy[1].isDisabled = !canViewTabs
      tabsCopy[2].isDisabled = !canViewTabs
      tabsCopy[3].isDisabled = !canViewTabs
      tabsCopy[4].isDisabled = !isAllowedToView('dashboard')
      tabsCopy[5].isDisabled = !isAllowedToView('dashboard.data')

      tabsCopy.sort((a, b) => a.custom_position - b.custom_position);
      setTabs(tabsCopy)
    }

    if (tabs.length < 6){
      getTabs()
    }

    // XXX Fix this in the future
    // eslint-disable-next-line
  }, [permissions])

  return {tabs}
}

export default useTabsNav
